module.exports = __webpack_public_path__ + "img/img02.cc7d5afd.jpg";